import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

function AdminClassLists() {

  const token = localStorage.getItem("access");
  const { t } = useTranslation();

  const [classes, setClasses] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");

  const [students, setStudents] = useState([]);

  const [className, setClassName] = useState("");

  const printRef = useRef();

  // =====================================================
  // FETCH CLASSES
  // =====================================================

  useEffect(() => {

    fetchClasses();

  }, []);

  const fetchClasses = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/academics/classes/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      setClasses(res.data);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // FETCH STUDENTS
  // =====================================================

  const fetchStudents = async (classId) => {

    try {

      const res = await axios.get(
        `https://api.eduskot.com/api/academics/class-students/${classId}/`,
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      const sortedStudents = res.data.students.sort(
        (a,b)=>
          a.full_name.localeCompare(
            b.full_name
          )
      );

      setStudents(sortedStudents);

      setClassName(res.data.class);

    } catch (err) {

      console.error(err);
    }
  };

  // =====================================================
  // HANDLE CLASS CHANGE
  // =====================================================

  const handleClassChange = (e) => {

    const value = e.target.value;

    setSelectedClass(value);

    if (value) {

      fetchStudents(value);
    }
  };

  // =====================================================
  // COUNTERS
  // =====================================================

  const boys = students.filter(
    (s)=>s.gender === "M"
  ).length;

  const girls = students.filter(
    (s)=>s.gender === "F"
  ).length;

  // =====================================================
  // PRINT
  // =====================================================

  const printClassList = () => {

    const printContents =
      printRef.current.innerHTML;

    const win = window.open("", "", "width=1200,height=800");

    win.document.write(`
      <html>

        <head>

          <title>Class List</title>

          <style>

  body{
    font-family: Arial, sans-serif;
    padding:10px;
    margin:0;
  }

  .school-header{
    text-align:center;
    margin-bottom:18px;
  }

  .school-header h1{
    font-size:26px;
    margin:0 0 6px 0;
  }

  .school-header h2{
    font-size:18px;
    margin:0 0 5px 0;
  }

  .school-header p{
    font-size:13px;
    margin:4px 0 12px 0;
  }

  .summary{
    display:flex;
    justify-content:space-between;
    margin-bottom:12px;
    font-size:13px;
    font-weight:bold;
  }

  table{
    width:100%;
    border-collapse:collapse;
    table-layout:fixed;
  }

  th{
    background:#e2e8f0;
    border:1px solid #000;
    padding:6px 4px;
    text-align:center;
    font-size:11px;
    line-height:1.1;
  }

  td{
    border:1px solid #000;
    padding:5px 4px;
    font-size:11px;
    line-height:1.15;

    /* VERY IMPORTANT */
    white-space:normal;
    overflow-wrap:break-word;
    word-break:normal;
    vertical-align:middle;
  }

  /* COLUMN WIDTHS */

  th:nth-child(1),
  td:nth-child(1){
    width:4%;
  }

  th:nth-child(2),
  td:nth-child(2){
    width:23%;
    text-align:left;
  }

  th:nth-child(3),
  td:nth-child(3){
    width:10%;
  }

  th:nth-child(4),
  td:nth-child(4){
    width:6%;
  }

  th:nth-child(5),
  td:nth-child(5){
    width:17%;
  }

  th:nth-child(6),
  td:nth-child(6){
    width:24%;
  }

  th:nth-child(7),
  td:nth-child(7){
    width:16%;
  }

  .center{
    text-align:center;
  }

  @media print{

    body{
      padding:10px;
    }

    table{
      width:100%;
    }

    th,
    td{
      page-break-inside:avoid;
    }

  }

</style>
        </head>

        <body>

          ${printContents}

        </body>

      </html>
    `);

    win.document.close();

    win.print();
  };

  return (

    <div style={styles.page}>

      {/* HEADER */}

      <div style={styles.header}>

        <h1>
          {t("professionalClassListGenerator")}
        </h1>

        <div style={{ display:"flex", gap:"10px" }}>

          <button
  style={{
    ...styles.printBtn,
    background:"#f59e0b"
  }}
  onClick={() =>
    window.location.href =
    "/admin-assessment-register"
  }
>
  Assessment Register
</button>

<button
  style={styles.printBtn}
  onClick={printClassList}
>
  {t("printPdf")}
</button>

<button
  style={styles.backBtn}
  onClick={() =>
    window.location.href =
    "/admin-dashboard"
  }
>
  {t("back")}
</button>

        </div>

      </div>

      {/* CLASS SELECT */}

      <div style={styles.topCard}>

        <select
          value={selectedClass}
          onChange={handleClassChange}
          style={styles.select}
        >

          <option value="">
            {t("selectClass")}
          </option>

          {classes.map((c)=>(

           <option key={c.id} value={c.id}>
    {c["department__name"]
        ? `${c.name} (${c["department__name"]})`
        : c.name}
</option>

          ))}

        </select>

      </div>

      {/* CLASS LIST */}

      {students.length > 0 && (

        <div
          ref={printRef}
          style={styles.tableCard}
        >

          {/* HEADER */}

          <div className="school-header">

            <h1 style={styles.schoolName}>
              {students[0]?.school_name || "SCHOOL NAME"}
            </h1>

            <h2 style={styles.classTitle}>
              {className} CLASS LIST
            </h2>

            <p style={styles.subTitle}>
  Academic Year: {students[0]?.session || "--"}
</p>

          </div>

          {/* SUMMARY */}

          <div style={styles.summary}>

            <div>
              <strong>{t("total")}:</strong>
              {" "}
              {students.length}
            </div>

            <div>
              <strong>{t("boys")}:</strong>
              {" "}
              {boys}
            </div>

            <div>
              <strong>{t("girls")}:</strong>
              {" "}
              {girls}
            </div>

          </div>

          {/* TABLE */}

          <table style={styles.table}>

            <thead>

              <tr>

                <th style={styles.th}>
                  {t("no")}
                </th>

                <th style={styles.th}>
                  {t("fullName")}
                </th>

                <th style={styles.th}>
                  {t("admissionNo")}
                </th>

                <th style={styles.th}>
                  {t("gender")}
                </th>

                <th style={styles.th}>
                  Place of Birth
                </th>

                <th style={styles.th}>
                  {t("parentContact")}
                </th>
                <th style={styles.th}>
                  NIU
                </th>

              </tr>

            </thead>

            <tbody>

              {students.map((student,index)=>(

                <tr key={student.id}>

                  <td style={styles.centerTd}>
                    {index + 1}
                  </td>

                  <td style={styles.td}>
                    {student.full_name}
                  </td>

                  <td style={styles.centerTd}>
                    {student.admission_number}
                  </td>

                  <td style={styles.centerTd}>
                    {student.gender}
                  </td>

                  <td style={styles.centerTd}>
                    {student.place_of_birth || "--"}
                  </td>

 <td style={styles.centerTd}>
  {student.parent_phone ? (
    <a
      href={`https://wa.me/237${student.parent_phone.replace(/\D/g, "")}?text=${encodeURIComponent(
        `Dear ${
          student.father_name && student.mother_name
            ? `Mr. ${student.father_name} and Mrs. ${student.mother_name}`
            : student.father_name
            ? `Mr. ${student.father_name}`
            : student.mother_name
            ? `Mrs. ${student.mother_name}`
            : "Parent/Guardian"
        },

This message is from ${student.school_name || "the school"} concerning your child, ${student.full_name}, who is in ${className}.

Cher ${
          student.father_name && student.mother_name
            ? `M. ${student.father_name} et Mme ${student.mother_name}`
            : student.father_name
            ? `M. ${student.father_name}`
            : student.mother_name
            ? `Mme ${student.mother_name}`
            : "Parent/Tuteur"
        },

Ce message vient de ${student.school_name || "l'établissement"} concernant votre enfant, ${student.full_name}, qui est en ${className}.`
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#6b19f0",
        fontWeight: "800",
        textDecoration: "none",
        cursor: "pointer"
      }}
    >
      {student.parent_phone}
    </a>
  ) : (
    "--"
  )}
</td>

                <td style={styles.centerTd}>
                  {student.niu || "--"}
                </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>
      )}

    </div>
  );
}

const styles = {

  page:{
    minHeight:"100vh",
    padding:"5px",
    background:"#f1f5f9",
    fontFamily:"Segoe UI"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    marginBottom:"30px",
    flexWrap:"wrap",
    gap:"10px"
  },

  topCard:{
    background:"white",
    padding:"20px",
    borderRadius:"14px",
    marginBottom:"30px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)"
  },

  select:{
    width:"100%",
    padding:"14px",
    borderRadius:"10px",
    border:"1px solid #cbd5e1"
  },

  tableCard:{
    background:"white",
    padding:"30px",
    borderRadius:"14px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)"
  },

  schoolName:{
    textAlign:"center",
    marginBottom:"10px",
    fontSize:"36px"
  },

  classTitle:{
    textAlign:"center",
    marginBottom:"10px"
  },

  subTitle:{
    textAlign:"center",
    color:"#64748b",
    marginBottom:"30px"
  },

  summary:{
    display:"flex",
    justifyContent:"space-between",
    marginBottom:"20px",
    fontSize:"16px"
  },

  table:{
    width:"100%",
    borderCollapse:"collapse"
  },

  th:{
    border:"1px solid #000",
    padding:"12px",
    background:"#e2e8f0",
    textAlign:"center"
  },

  td:{
    border:"1px solid #000",
    padding:"10px"
  },

  centerTd:{
    border:"1px solid #000",
    padding:"10px",
    textAlign:"center"
  },

  backBtn:{
    padding:"10px 18px",
    border:"none",
    borderRadius:"10px",
    background:"#2563eb",
    color:"white",
    cursor:"pointer"
  },

  printBtn:{
    padding:"10px 18px",
    border:"none",
    borderRadius:"10px",
    background:"#16a34a",
    color:"white",
    cursor:"pointer"
  }
};

export default AdminClassLists;